module.exports = __webpack_public_path__ + "static/media/24-6.52064dcb.mp3";